//redux
import { combineReducers } from 'redux';
//reducers
import { navReducer } from './Nav/Reducers/Nav.reducers';

export const root = combineReducers({
  nav: navReducer,
});
